let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3yAcv")).then(() => parcelRequire('5hPMC'));